import React, { FC } from "react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import classNames from "classnames"

type Props = {
  open: boolean
  close: () => void
  children: JSX.Element | JSX.Element[]
  width: "x-small" | "small" | "medium" | "large"
  title: string
}

export const Modal: FC<Props> = (props) => {
  if (!props.open) return <></>

  return (
    <div className="bg-secondary-6 bg-opacity-50 backdrop-blur-sm fixed px-4 top-0 left-0 w-full h-full flex items-center z-20">
      <div
        className={classNames({
          "mx-auto rounded-2xl pb-6 relative z-30":
            true,
          "md:w-97 w-full": props.width === "x-small",
          "2xl:w-1/3 lg:w-1/2 md:w-full w-full": props.width === "small",
          "2xl:w-2/3 lg:w-3/4 md:w-full w-full": props.width === "medium",
          "2xl:w-4/5 lg:w-4/5 md:w-full w-full": props.width === "large",
        })}
      >
        <div className="bg-primary-3 dark:bg-secondary-2 py-4 rounded-t-2xl px-4 w-full flex justify-between items-center">
         <h2 className="font-medium text-sm text-white">{props.title}</h2>
          <XMarkIcon
            className="w-4 h-4 text-light-1 rounded-full bg-white cursor-pointer"
            onClick={props.close}
          />
        </div>
        <div className="px-3 bg-[#fafafa] dark:border-x-2 dark:border-b-2  border-secondary-2 dark:bg-primary-1 p-4 rounded-b-2xl max-h-[90vh] overflow-auto">{props.children}</div>
      </div>
    </div>
  )
}
